import React from 'react';
import { getOilQuantityAssessment, getOilQuantityProfile } from '../utils/oilQuantity';
import './OilQuantityGuide.css';

export const OilQuantityMessage = ({ value, aircraftType }) => {
  const assessment = getOilQuantityAssessment(value, aircraftType);
  if (!assessment.message) return <div className="oil-guidance-message-spacer" aria-hidden="true" />;
  return <div className={`oil-guidance-message ${assessment.status}`}>{assessment.message}</div>;
};

const OilQuantityGuide = ({ aircraftType }) => {
  const profile = getOilQuantityProfile(aircraftType);
  return (
    <div className={`oil-level-guide oil-level-${profile.key}`}>
      <div className="oil-level-heading">
        <span>Quantity Level</span>
      </div>
      <div className="oil-level-track" aria-label={`${profile.label} oil quantity limits`}>
        <span className="critical" />
        <span className="caution" />
        <span className="normal" />
        <span className="caution" />
      </div>
      <div className="oil-level-labels">
        {profile.labels.map((label, index) => (
          <span className={index === 0 ? 'critical' : (index === 2 ? 'normal' : 'caution')} key={label}>{label}</span>
        ))}
      </div>
    </div>
  );
};

export default OilQuantityGuide;
